<div class="mdc-card" [style.animation-delay]="animationDelay + 'ms'" (click)="onCardClick()">
  <div class="mdc-header">
    <span class="mdc-title">{{ title }}</span>
    <i class="bi mdc-chevron"
       [class.bi-chevron-right]="!expandable"
       [class.bi-chevron-down]="expandable && !expanded"
       [class.bi-chevron-up]="expandable && expanded"></i>
  </div>
  <div class="mdc-chips" *ngIf="chipFields.length > 0">
    <span class="mdc-chip" *ngFor="let f of chipFields" [class.mdc-chip--warn]="f.warn" [class.mdc-chip--success]="f.tone === 'success'" [class.mdc-chip--danger]="f.tone === 'danger'">
      <span class="mdc-chip-label">{{ f.label }}</span>
      <span class="mdc-chip-value">{{ f.value }}</span>
    </span>
  </div>
  <div class="mdc-fields" *ngIf="listFields.length > 0 && (!expandable || expanded)">
    <div class="mdc-field" *ngFor="let f of listFields" [class.mdc-field--warn]="f.warn">
      <span class="mdc-field-label">{{ f.label }}</span>
      <span class="mdc-field-value"
        [class.mdc-field-value--active]="f.type === 'status' && f.value === 'Active'"
        [class.mdc-field-value--inactive]="f.type === 'status' && f.value === 'Inactive'"
        [class.mdc-field-value--primary]="f.tone === 'primary'">{{ f.value }}</span>
    </div>
  </div>
  <div class="mdc-footer" *ngIf="primaryValue || badgeLabel">
    <span class="mdc-primary-value" *ngIf="primaryValue">{{ primaryValue }}</span>
    <span class="mdc-badge" *ngIf="badgeLabel">{{ badgeLabel }}</span>
  </div>
  <div class="mdc-expand" *ngIf="expandable && expanded" (click)="$event.stopPropagation()">
    <ng-content></ng-content>
  </div>
  <div class="mdc-actions" *ngIf="hasActions" (click)="$event.stopPropagation()">
    <button *ngIf="resetPasswordTap.observed" class="mdc-action-btn mdc-action-btn--reset"
      (click)="resetPasswordTap.emit(fullItem)">
      <i class="bi bi-key"></i> Reset
    </button>
    <button *ngIf="editTap.observed" class="mdc-action-btn mdc-action-btn--edit"
      (click)="editTap.emit(fullItem)">
      <i class="bi bi-pencil"></i> Edit
    </button>
    <button *ngIf="deleteTap.observed" class="mdc-action-btn mdc-action-btn--delete"
      (click)="deleteTap.emit(fullItem)">
      <i class="bi bi-trash"></i> Delete
    </button>
  </div>
</div>
